import {
	HorizontalSpacingTokens,
	VerticalSpacingTokens,
} from "@fluentui/react-components";
import { CSSProperties } from "react";

export interface FlexProps {
	children: any;
	column?: boolean;
	gap?: GapSize;
	wrap?: "nowrap" | "wrap" | "wrap-reverse";
	hAlign?:
		| "flex-start"
		| "flex-end"
		| "center"
		| "space-between"
		| "space-around"
		| "space-evenly";
	vAlign?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline";
	className?: string;
	style?: CSSProperties;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
	id?: string;
}

export enum GapSize {
	None = "None", // 0px
	ExtraSmall = "XS", // 4px
	Small = "S", // 8px
	Medium = "M", // 12px
	Large = "L", // 16px
	ExtraLarge = "XL", // 20px
	XXXLarge = "XXXL", // 28px
}

export function convertToGap(
	size?: GapSize,
	isColumn?: boolean
): keyof HorizontalSpacingTokens | keyof VerticalSpacingTokens {
	const axis: string = !!isColumn ? "Vertical" : "Horizontal";
	const value: string = size ?? GapSize.None;

	return `spacing${axis}${value}` as
		| keyof HorizontalSpacingTokens
		| keyof VerticalSpacingTokens;
}
